import React, { useRef, useState, useEffect } from 'react';
import Styles from './checkName.module.scss';
import { isEmpty } from 'lodash';
import cn from 'classnames';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import PhoneNumberComponent from '@components/common/PhoneNumberComponent/index';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { replaceAll } from '@utility/utills';
import CustomKeyboard from '@components/common/CustomKeyboard/index';

const checkName = (props) => {
  const themeProperties = JSON.parse(window.sessionStorage.getItem('themeProperties')) || {};
  const keyboard = useRef(null);
  const [typed, setTyped] = useState({});
  const [keyboardType, setKeyboardType] = useState(props.inputFields.nameEnabled === true ? 'kiosk' : 'number');
  const [inputs, setInputs] = useState({
    checkName: '', error: '', phoneNumber: ''
  });
  const [notification, setNotification] = useState(false);
  const [openKeyboard, setOpenKeyboard] = useState(true);
  const [inputName, setInputName] = useState(props.inputFields.nameEnabled === true ? 'checkName' : 'phoneNumber');

  const handleBlur = () => {
    setOpenKeyboard(true);
    if (props.inputFields.nameEnabled) {
      document.querySelector('#checkName').blur();
    }
    if (props.inputFields.phoneNumberEnabled) {
      document.querySelector('#phoneNumber').blur();
    }
  };

  useEffect(() => {
    setInputs({
      ...inputs,
      [inputName]: inputs[inputName]
    });
  }, [openKeyboard]);

  const setEmpty = (data) => {
    setInputs({
      ...inputs,
      [data]: '',
      error: '',
    });
    setTyped({
      ...typed,
      [data]: ''
    });

    if (data === 'phoneNumber') {
      setNotification(false);
    }
  };
  const closeKeyboard = () => {
    setOpenKeyboard(false);
  };

  useEffect(() => {
    if (keyboard.current) {
      setEmpty('phoneNumber');
    }
  }, [props.countryCode]);

  const validateTable = () => {
    return new Promise((resolve, reject) => {
      let errorMessage = {};
      const phoneLength = replaceAll(inputs.phoneNumber, '-');
      if (props.inputFields.nameEnabled && props.inputFields.nameRequired) {
        if (inputs?.checkName === '') {
          errorMessage = { ...errorMessage, checkName: ' Name is required' };
        }
      }
      if (props.inputFields.phoneNumberEnabled && props.inputFields.phoneNumberRequired) {
        if (inputs?.phoneNumber === '') {
          errorMessage = { ...errorMessage, phoneNumber: 'Phone number is required' };
        } else if (Number(props.countryCode) === 1 && inputs?.phoneNumber.length > 0 && phoneLength?.length < Number(props.phoneNumberMaxLength)) {
          errorMessage = { ...errorMessage, phoneNumber: `Phone number length must be ${props.phoneNumberMaxLength} digits` };
        } else if (inputs?.phoneNumber?.length > 0 && !notification) {
          errorMessage = { ...errorMessage, checkbox: 'Terms must be accepted' };
        }
      }

      if (Number(props.countryCode) === 1 && inputs?.phoneNumber.length > 0 && phoneLength?.length < Number(props.phoneNumberMaxLength)) {
        errorMessage = { ...errorMessage, phoneNumber: `Phone number length must be ${props.phoneNumberMaxLength} digits` };
      } else if (inputs?.phoneNumber?.length > 0 && !notification) {
        errorMessage = { ...errorMessage, checkbox: 'Terms must be accepted' };
      }

      if (isEmpty(errorMessage)) {
        resolve();
      } else {
        reject(errorMessage);
      }
    });
  };
  const getInputValue = (inputNameDat) => {
    return (inputs[inputNameDat]) || '';
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;

    setInputs({
      ...keyboard.current.input,
      [inputName]: inputVal
    });

    keyboard.current.setInput(inputVal, inputName);
  };

  const handleSubmit = () => {
    validateTable().then(() => {
      props.submitTab(typed);
    }).catch((err) => {
      setInputs({ ...inputs, error: err });
    });
  };

  const changeActiveElement = () => {
    setOpenKeyboard(true);
    setInputName('phoneNumber');
    setKeyboardType('number');
  };

  const returnMaxLength = () => {
    if (Number(props.countryCode) === 1 && inputs?.phoneNumber.includes('-')) {
      return 10;
    }
    return props.phoneNumberMaxLength;
  };
  const onClickBtn = (e) => {
    setTyped(e === '{bksp}' ? { ...typed, [inputName]: typed[inputName]?.slice(0, -1) } : { ...typed, [inputName]: typed[inputName] ? typed[inputName].concat(e) : ''.concat(e) });
    const value = e === '{bksp}' ? { ...typed, [inputName]: typed[inputName]?.slice(0, -1) } : { ...typed, [inputName]: typed[inputName] ? typed[inputName].concat(e) : ''.concat(e) };
    setInputs({
      ...inputs,
      [inputName]: inputName === 'phoneNumber' && Number(props.countryCode) === 1 ? getFormatedPhoneNumber(value[inputName]) : value[inputName]
    });
  };

  return (
    <div className="h-100 m-0">
      {!props.isHeight && (
        <div className="col-12 h-50 p-0 text-center">
          <img
            src={themeProperties.kioskHeroImageUrl}
            alt=""
            className={`img-fluid d-block mx-auto w-100 ${Styles.maxHeight}`}
            style={{objectFit: 'contain'}}
          />
        </div>
      )}
      <div className={props.isHeight ? 'h-100' : 'h-50'}>
        {props.inputFields.nameEnabled
          ? (
            <div className="col-12 m-0 row align-items-center justify-content-center px-4 h-35 large-input position-relative">
              <div className="row text-center text-primary od-text-primary fs-24 align-items-center justify-content-center">{CUSTOM_MESSAGES().NAME_FOR_THIS_ORDER}</div>
              <div className={cn('h-50 col-12 p-0 position-relative', inputName === 'checkName' ? 'border od-container-card-border border-color-primary' : '')}>
                <input
                  value={getInputValue('checkName')}
                  type="text"
                  ref={keyboard}
                  className="col-12 form-control h-100 opacity-30"
                  placeholder={props.inputFields.nameRequired ? `${LABEL().NAME_REQUIRED}` : `${LABEL().NAME_OPTIONAL}`}
                  style={{ fontSize: '3vh' }}
                  id="checkName"
                  name="checkName"
                  onFocus={() => { handleBlur(); setInputName('checkName'); setKeyboardType('kiosk'); setOpenKeyboard(true); }}
                  onChange={onChangeInput}
                />
                {inputs?.error && <div className="text-center col-12 fs-12 text-primary">{inputs.error.checkName}</div>}
                {inputs?.checkName?.length > 0 && (
                  <div
                    role="presentation"
                    className="position-absolute"
                    style={{
                      right: '20px', top: '50%', transform: 'translateY(-50%)', zIndex: '999'
                    }}
                    onClick={() => { setEmpty('checkName'); }}
                  >
                    <i className="fa fa-times text-secondary od-text-secondary fs-14" aria-hidden="true" />
                  </div>
                  )}
              </div>
            </div>) : null }
        {props.inputFields.phoneNumberEnabled
          ? (
            <div className="col-12 m-0 row justify-content-center align-items-center h-35 fs-24 px-4 large-input position-relative">
              <div className="row text-center text-primary od-text-primary align-items-center justify-content-center">{CUSTOM_MESSAGES().DO_WANT_US_TO_TEXT}</div>
              <div className={cn('h-50 col-12 p-0 position-relative', inputName === 'phoneNumber' ? 'border od-container-card-border border-color-primary' : '')}>
                <PhoneNumberComponent
                  countryCode={props.countryCode}
                  handleCountryCodeChange={(e) => { setInputName('phoneNumber'); props.handleCountryCodeChange(e); }}
                  onSelect={() => changeActiveElement()}
                  isHeight={props.isHeight}
                  styles={{
                    top: '50%',
                    left: 0,
                    transform: 'translateY(-50%)',
                    padding: 'p-2',
                    zIndex: 999
                  }}
                />
                <input
                  value={getInputValue('phoneNumber')}
                  type="text"
                  className="col-12 form-control h-100 opacity-30"
                  placeholder={props.phoneNumberRequired ? `${LABEL().PHONE_REQUIRED}` : `${LABEL().PHONE_OPTIONAL}`}
                  style={{ fontSize: '3vh' }}
                  id="phoneNumber"
                  name="phoneNumber"
                  maxLength={Number(props.phoneNumberMaxLength)}
                  onFocus={() => { handleBlur(); setInputName('phoneNumber'); setKeyboardType('number'); }}
                  onChange={onChangeInput}
                />
                {inputs?.error && <div className="text-center col-12 fs-12 text-primary">{inputs.error.checkbox || inputs.error.phoneNumber}</div>}
                {inputs?.phoneNumber?.length > 0 && (
                <div
                  role="presentation"
                  className="position-absolute"
                  style={{ right: '20px', top: '50%', transform: 'translateY(-50%)' }}
                  onClick={() => { setEmpty('phoneNumber'); }}
                >
                  <i className="fa fa-times text-secondary od-text-secondary fs-14" aria-hidden="true" />
                </div>
                    )}
              </div>
            </div>) : null }
        {props.inputFields.phoneNumberEnabled
          ? (
            <div className="d-flex px-4 py-2 h-10">
              <input type="checkbox" className={cn(Styles.checkbox, '')} disabled={inputs.phoneNumber.length === 0} id="phoneNumber" name="phoneNumber" checked={notification} onClick={() => { setNotification(!notification); setInputs({ ...inputs, error: '' }); }} />
              <div className="fs-12 text-secondary od-text-secondary px-2">{CUSTOM_MESSAGES().I_AGREE_TO_RECEIV_TEXT}<br /></div>
            </div>) : null }
        <div className={props.inputFields.phoneNumberEnabled === true && props.inputFields.nameEnabled === true ? 'row h-20 m-0 justify-content-center align-items-end w-100 px-4' : [props.inputFields.nameEnabled === true ? 'row h-65 m-0 justify-content-center align-items-end w-100 px-4' : 'row h-55 m-0 justify-content-center align-items-end w-100 px-4']}>
          <button
            className={cn('w-70 btn btn100 btn-primary btn-ripple od-btn-primary rounded')}
            type="submit"
            onClick={() => handleSubmit()}
          >
            <div className="fs-30">{LABEL().KIOSK_CONTINUE}</div>
          </button>
        </div>
        {openKeyboard ? (
          <div className={cn('p-0 m-0 background-primary od-app-background-color od-border-secondary', keyboardType === 'number' || keyboardType === 'numericAlpha' ? Styles.keyboard : Styles.keyboard1)}>
            <div className={cn(inputName === 'phoneNumber' ? 'col-6 text-center position-absolute' : 'col-12 p-0 text-right position-absolute', Styles.arrow)}>
            </div>          
            <CustomKeyboard
              setKeyboardType={setKeyboardType}
              onClickBtn={(e) => onClickBtn(e)}
              type={keyboardType}
              typed={typed[inputName] || ''}
              closeKeyboard={closeKeyboard}
              btnSize="btn35"
              customClass="fs-30 background-primary od-app-background-color"
              maxLength={inputName === 'phoneNumber' ? returnMaxLength() : props.maxLength}           
            />
          </div>
        ) : (
          <div role="presentation" className={cn('col-12 text-right position-absolute', Styles.btmArrow)} onClick={() => setOpenKeyboard(true)}>           
          </div>
        )}
      </div>
    </div>
  );
};

export default checkName;
